import { render, staticRenderFns } from "./BranchSEditDialog.vue?vue&type=template&id=24dff8f8&scoped=true&"
import script from "./BranchSEditDialog.vue?vue&type=script&lang=js&"
export * from "./BranchSEditDialog.vue?vue&type=script&lang=js&"
import style0 from "./BranchSEditDialog.vue?vue&type=style&index=0&id=24dff8f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dff8f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDialog,VIcon})
